import React, { useEffect, useState } from "react";
import TauriImage from "../../../TauriImage/TauriImage";
import TauriLoader2 from "../../../TauriLoader2/TauriLoader2";
import { Modal, Button } from "react-bootstrap";
import Camera from "../../../OpalCoverageLayout/CoverageView/FinishSessionModal/Camera/Camera";
import SignatureDrawing from "../../../OpalCoverageLayout/CoverageView/FinishSessionModal/SignatureDrawing/SignatureDrawing";
import "./OpalDayProofModal.css";
import OpalAlertModal from "../../../OpalAlertModal/OpalAlertModal";
import { addRecord, getNextId, updateRecord } from "../../../../localDB";
import appURL from '../../../../appURL.json';
import { useBaseProvider } from "../../../../BaseManager/BaseManager";
import { SyncStatusMap } from "../../../../visualizations/visualizations";

const OpalDayProofModal = ({ show, onHide, headerTitle, onDay, attendance }) => {

    const [loading, setLoading] = useState(false);
    const [captureImage, setCaptureImage] = useState(null);
    const [signatureImage, setSignatureImage] = useState(null);
    const [currentTime, setCurrentTime] = useState(new Date());
    const [showCamera, setShowCamera] = useState(false);
    const [location, setLocation] = useState(null);
    const [locationError, setLocationError] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [sessionAction, setSessionAction] = useState(null);
    const [loadingAddress, setLoadingAddress] = useState(false);

    const { setTimeIn, setTimeOut } = useBaseProvider();

    const isOnline = JSON.parse(localStorage.getItem("isOnline"));
    const hasInternet = navigator.onLine;

    const reset = () => {
        setCaptureImage(null);
        setSignatureImage(null);
        setShowCamera(false);
    }

    const validateSubmission = () => {
        if (!captureImage) return "No Proof Image. Please take a photo.";
        if (!signatureImage) return "No Signature. Please sign before submitting.";
        if (!location) return "No Location. Please enable your location services.";
        return null;
    };

    const openCamera = () => {
        setShowCamera(true);
    };

    const getLocation = async () => {
        setLoadingAddress(true);
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;

                    let locationData = { latitude, longitude };

                    if (isOnline && hasInternet) {
                        try {
                            const token = localStorage.getItem("token");
                            const response = await fetch(`${appURL.API_GetLocationAddress}?lat=${latitude}&long=${longitude}`, {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${token}`,
                                }
                            });

                            const data = await response.json();

                            const address = data;

                            locationData.address = address;
                        } catch (err) {
                            console.error("Reverse geocoding failed:", err);
                        }
                    }

                    setLoadingAddress(false);
                    setLocation(locationData);
                    setLocationError(null);
                    resolve(locationData);
                },
                (error) => {
                    console.error(error);
                    setLoadingAddress(false);
                    setLocationError("Unable to retrieve location. Please enable location services.");
                    setLocation(null);
                    reject("Unable to retrieve location");
                },
                {
                    enableHighAccuracy: true,
                    timeout: 20000, // stop waiting forever
                    maximumAge: 10000
                }
            );
        });
    };

    const handleCapture = (img) => {
        setCaptureImage(img);
    };



    const OnlineAttendance = async (img, sign) => {
        try {

            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");
            const loc = {
                lat: location.latitude,
                long: location.longitude,
            }

            const formData = new FormData();

            formData.append("p", img.ImageData, img.FileName);
            formData.append("s", sign.ImageData, sign.FileName);
            formData.append("loc", JSON.stringify(loc));

            const response = await fetch(appURL.API_SendAttendance, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "X-ETR-Device-ID": devId
                },
                body: formData
            });

            const data = await response.json();
            if (!response.ok) {
                if (data?.code) {
                    return { error: data?.description || "Attendance Failed!" };
                } else {
                    return { error: "Attendance Failed!" };
                }
            }

            return { serverDate: data?.server_date };

        } catch (error) {
            return { error: "Attendance Failed!" };
        }
    };

    const handleTimeIn = async () => {
        const errorMessage = validateSubmission();
        if (errorMessage) {
            setSessionAction({
                title: "Missing",
                bodyText: errorMessage,
                onConfirm: () => setShowMessage(false),
                confirmText: "OK"
            });
            setShowMessage(true);
            return;
        }

        try {
            setLoading(true);
            const nextID = await getNextId("Attendance");
            const RecipientPhotoFileID = await getNextId("RecipientPhotoFile");
            const RecipientSignatureFileID = await getNextId("RecipientSignatureFile");
            const imageExt = getExtensionFromBlob(captureImage) || 'png';
            const signatureExt = getExtensionFromBlob(signatureImage) || 'png';

            const formattedDate = formatDateForFilename(currentTime);
            const newRecipientPhotoFile = {
                ID: RecipientPhotoFileID,
                SessionID: null,
                ImageData: captureImage || "",
                FileName: `in_${formattedDate}.${imageExt}`
            };

            const newRecipientSignatureFile = {
                ID: RecipientSignatureFileID,
                SessionID: null,
                ImageData: signatureImage || "",
                FileName: `s_in_${formattedDate}.${signatureExt}`
            };

            let result = null;
            if (isOnline && hasInternet) {
                result = await OnlineAttendance(newRecipientPhotoFile, newRecipientSignatureFile);

                if (result?.error) {
                    setSessionAction({
                        title: "Attendance",
                        bodyText: result.error,
                        onConfirm: () => setShowMessage(false),
                        confirmText: "OK"
                    });
                    setShowMessage(true);
                    return;
                }
            }

            const record = {
                ID: nextID,
                Date: result?.serverDate ? new Date(result.serverDate).toLocaleDateString("en-CA") : currentTime.toLocaleDateString("en-CA"),
                TimeIn: result?.serverDate ?? currentTime.toISOString(),
                IN_SignatureFileID: RecipientSignatureFileID,
                IN_PhotoFileID: RecipientPhotoFileID,
                IN_LocationLat: location.latitude,
                IN_LocationLong: location.longitude,
                IN_Address: location.address,
                TimeOut: null,
                OUT_SignatureFileID: null,
                OUT_PhotoFileID: null,
                OUT_LocationLat: null,
                OUT_LocationLong: null,
                OUT_Address: null
            };

            if (!result?.serverDate) {
                record.SyncStatus = SyncStatusMap.create;
            }

            await addRecord("Attendance", record);
            await addRecord("RecipientPhotoFile", newRecipientPhotoFile);
            await addRecord("RecipientSignatureFile", newRecipientSignatureFile);

            onDay(record);
            setTimeIn(true);
            reset();
            onHide();
        } catch (error) {
            console.error("Failed to save sessions:", error);
        } finally {
            setLoading(false);
        }
    }

    const handleTimeOut = async () => {
        const errorMessage = validateSubmission();
        if (errorMessage) {
            setSessionAction({
                title: "Missing",
                bodyText: errorMessage,
                onConfirm: () => setShowMessage(false),
                confirmText: "OK"
            });
            setShowMessage(true);
            return;
        }

        try {
            setLoading(true);

            const RecipientPhotoFileID = await getNextId("RecipientPhotoFile");
            const RecipientSignatureFileID = await getNextId("RecipientSignatureFile");
            const imageExt = getExtensionFromBlob(captureImage) || 'png';
            const signatureExt = getExtensionFromBlob(signatureImage) || 'png';

            const formattedDate = formatDateForFilename(currentTime);
            const newRecipientPhotoFile = {
                ID: RecipientPhotoFileID,
                SessionID: null,
                ImageData: captureImage || "",
                FileName: `out_${formattedDate}.${imageExt}`
            };

            const newRecipientSignatureFile = {
                ID: RecipientSignatureFileID,
                SessionID: null,
                ImageData: signatureImage || "",
                FileName: `s_out_${formattedDate}.${signatureExt}`
            };

            let result = null;
            if (isOnline && hasInternet) {
                result = await OnlineAttendance(newRecipientPhotoFile, newRecipientSignatureFile);

                if (result?.error) {
                    setSessionAction({
                        title: "Attendance",
                        bodyText: result.error,
                        onConfirm: () => setShowMessage(false),
                        confirmText: "OK"
                    });
                    setShowMessage(true);
                    return;
                }
            }

            const endDay = {
                ...attendance,
                TimeOut: result?.serverDate ?? currentTime.toISOString(),
                OUT_SignatureFileID: RecipientSignatureFileID,
                OUT_PhotoFileID: RecipientPhotoFileID,
                OUT_LocationLat: location.latitude,
                OUT_LocationLong: location.longitude,
                OUT_Address: location.address
            }

            if (!result?.serverDate) {
                endDay.SyncStatus = SyncStatusMap.update;
            }

            await updateRecord("Attendance", endDay);
            await addRecord("RecipientPhotoFile", newRecipientPhotoFile);
            await addRecord("RecipientSignatureFile", newRecipientSignatureFile);

            onDay(endDay);
            setTimeOut(true);
            reset();
            onHide();
        } catch (error) {
            console.error("Failed to save sessions:", error);
        } finally {
            setLoading(false);
        }
    }

    function getExtensionFromBlob(blob) {
        if (!blob || !blob.type) return '';
        const mime = blob.type; // e.g., "image/png"
        const ext = mime.split('/')[1]; // get "png"
        return ext || '';
    }

    function formatDateForFilename(date = new Date()) {
        const pad = (num) => String(num).padStart(2, '0');
        return (
            date.getFullYear().toString() +
            pad(date.getMonth() + 1) +
            pad(date.getDate())
        );
    }

    useEffect(() => {
        if (show) {
            reset(); // also reset internal state
            getLocation();
        }
    }, [show]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000); // update every second

        return () => clearInterval(timer); // cleanup on unmount
    }, []);

    const formattedTime = currentTime.toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    }).replace("at", ",");


    return (
        <Modal className="opal-proof-modal" show={show} onHide={onHide} centered>
            <Modal.Header>
                {headerTitle}
            </Modal.Header>
            <Modal.Body>
                <div className="proof-container half-height camera" onClick={!showCamera ? openCamera : undefined}>
                    {!showCamera ? (
                        <>
                            <TauriImage localImage={"/Images/iconoir--camera-solid.svg"} className={"start-camera-icon"} alt="icon" color={"#979797"} />
                            <div>Tap to Start Camera</div>
                        </>
                    ) : (
                        <Camera onCapture={handleCapture} textOverlay={`${location?.address} - ${formattedTime}`} />
                    )}
                </div>

                <div className="proof-container half-height signature">
                    <SignatureDrawing onSignatureChange={setSignatureImage} Signature={signatureImage} textOverlay={`${location?.address} - ${formattedTime}`} />
                    {!signatureImage && (
                        <div className="details">
                            {loadingAddress ? (
                                <span>Retrieving address...</span>
                            ) : location?.address && isOnline && hasInternet ? (
                                <span>{location.address}</span>
                            ) : (
                                <>
                                    <span>Latitude: {location?.latitude?.toFixed(2)}</span>{' '}
                                    <span>Longitude: {location?.longitude?.toFixed(2)}</span>
                                </>
                            )}
                            <div>{formattedTime}</div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="done-btn w-100"
                    onClick={attendance ? handleTimeOut : handleTimeIn}
                    disabled={loading || loadingAddress}
                >
                    {loading &&
                        <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.3rem" color="#FFF" />
                    }
                    <span>Done</span>
                </Button>
            </Modal.Footer>

            {sessionAction && (
                <OpalAlertModal
                    show={showMessage}
                    onHide={() => setShowMessage(false)}
                    title={sessionAction.title}
                    bodyText={sessionAction.bodyText}
                    onConfirm={sessionAction.onConfirm}
                    confirmButtonText={sessionAction.confirmText}
                    cancelButtonText=""
                    modalType="message"
                />
            )}

        </Modal>
    );
};

export default OpalDayProofModal;
